import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import FlexView from 'react-flexview';
import Avatar from '@material-ui/core/Avatar';
import {withRouter} from "react-router-dom"
import Constants from './constants'

class Header extends Component {

    Logout = () => {
        localStorage.clear()
        this.props.history.push('/login')
    }

    render() {
        const imgProfile = localStorage.getItem('picture')
        return (
            <div>
                <AppBar position="static"  style={{ backgroundColor: Constants.COLOR_PRIMARY }} >
                    <Toolbar>
                        <Typography variant="title" color="inherit">
                            Fondue
                        </Typography>
                        <FlexView style={{ flex: 1}} hAlignContent='right'>
                            <Avatar src={imgProfile} />
                            <Button color="inherit" onClick={() =>{ this.Logout() }}>Logout</Button>
                        </FlexView>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js